import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import React from "react";

const DailyMetrics = ({
  product,
  salesData,
  profitabilityData,
  showPPCChange,
  showTACOSChange,
  showACOSChange,
  showPOASChange,
  showVelocityChange,
  showProfitChange,
  showWeightedRankChange,
  tableProfitDataForProduct,
  calcDaysOfSupply,
  calcPredictedDaysOfSupply,
  velocityDays,
  isFilterActive,
  leaf,
  marketplace,
  asinFeaturesData, // New prop for the external feature value
  store,
}) => {
  const daysOfSupply = calcDaysOfSupply(salesData);
  const predictedDaysOfSupply = calcPredictedDaysOfSupply(asinFeaturesData);

  const getPredictedDaysOfSupplyIndicator = () => {
    if (predictedDaysOfSupply === undefined || predictedDaysOfSupply === null) {
      return null;
    }
    return predictedDaysOfSupply;
    // if (predictedDaysOfSupply === daysOfSupply) {
    //   return "";
    // } else {
    //   return predictedDaysOfSupply > daysOfSupply ? "+" : "-";
    // }
  };

  const predictedDaysOfSupplyIndicator = getPredictedDaysOfSupplyIndicator();

  // When filter is active on parent rows, hide all metrics to reduce row height
  if (isFilterActive) {
    return null;
  }

  return (
    <div>
      <div>
        {!product.children ? "" : "Avg "}Days of Supply
        <Tooltip
          title={
            <>
              {!product.children ? "" : "Average of all child variations - "}
              Realistic stock / Velocity
              <br />
              *Realistic Stock = Available + (Reserved - Customer orders) +
              In-Receiving + 3PL + AWD + FBA inbound (if ETA is within 15 days)
              {store === "rushmorerose" && (
                <>
                  or all FBA Inbound (if made in USA)
                  <br />
                </>
              )}
              <br />
              *Velocity = avg units sold per day in last
              {" " + velocityDays + " "}
              days
              <br />
              *if the DOS exceed 60, we will exclude AWD and 3PL from the
              calculation.
            </>
          }
        >
          <InfoIcon
            sx={{
              marginLeft: "3px",
              width: "14px",
              height: "14px",
              color: "#CBD5E1",
            }}
          />
        </Tooltip>
      </div>
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: 600,
          color: "black",
          fontSize: 24,
          textAlign: "left",
          marginBottom: "15px",
          marginLeft: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {daysOfSupply}
        {predictedDaysOfSupplyIndicator && marketplace !== "ca" && (
          <Tooltip
            title={`Model Predicted Days of Supply: ${predictedDaysOfSupply}`}
            arrow
          >
            <div>
              <span
                style={{
                  color: "#9404f1", // Gray color
                  fontSize: 15,
                  fontWeight: 600,
                  marginLeft: "5px",
                  cursor: "help",
                }}
              >
                {predictedDaysOfSupplyIndicator}
              </span>
              <img
                src="/assets/AI.png"
                alt="AI Model Predicted Days of Supply"
                style={{
                  width: "10px",
                  height: "10px",
                  marginTop: "8px",
                  position: "absolute",
                }}
              />
            </div>
          </Tooltip>
        )}
      </div>
      Daily Metrics:
      <Tooltip
        title={
          <>Last {velocityDays} days daily avarage compared to previous week</>
        }
      >
        <InfoIcon
          sx={{
            marginLeft: "3px",
            width: "14px",
            height: "14px",
            color: "#CBD5E1",
          }}
        />
      </Tooltip>
      <div
        style={{
          display: "flex",
          verticalAlign: "middle",
          alignItems: "center",
          marginTop: "5px",
          marginLeft: "10px",
        }}
      >
        <div
          style={{
            marginTop: "5px",
          }}
        >
          Units:
        </div>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: 18,
            textAlign: "left",
            marginBottom: "5px",
            marginLeft: "5px",
          }}
        >
          {showVelocityChange(salesData)}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          verticalAlign: "middle",
          marginLeft: "10px",
        }}
      >
        <div
          style={{
            marginTop: "5px",
          }}
        >
          Profit:
        </div>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: 18,
            textAlign: "left",
            marginBottom: "5px",
            marginLeft: "5px",
          }}
        >
          {showProfitChange(
            tableProfitDataForProduct(
              leaf === "yes"
                ? [profitabilityData]
                : Object.values(profitabilityData)
            )[0]
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          verticalAlign: "middle",
          marginLeft: "10px",
        }}
      >
        <div
          style={{
            marginTop: "5px",
          }}
        >
          PPC:
        </div>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: 18,
            textAlign: "left",
            marginBottom: "5px",
            marginLeft: "10px",
          }}
        >
          {showPPCChange(salesData)}
        </div>
      </div>
      <div
        style={{
          // fontFamily: "Inter",
          fontWeight: 600,
          fontSize: 10,
          color: "black",
          textAlign: "left",
          marginBottom: "0px",
          marginTop: "5px",
          display: "none",
        }}
      >
        {" TACOS:"}
        {showTACOSChange}
        <br />
        {" ACOS:"}
        {showACOSChange}
        <br />
        {" POAS:"}
        {showPOASChange}
      </div>
      {(leaf === "yes" || Object.keys(salesData).length === 1) && (
        <div style={{ display: "flex", verticalAlign: "bottom" }}>
          <div
            style={{
              marginTop: "5px",
              marginLeft: "10px",
            }}
          >
            Rank:
          </div>
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: 18,
              textAlign: "left",
              marginBottom: "5px",
              marginLeft: "10px",
            }}
          >
            {showWeightedRankChange(
              // reverse the weighted rank array
              leaf === "yes"
                ? salesData?.weightedRank
                : Object.values(salesData)?.[0]?.weightedRank
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export { DailyMetrics };
